module.exports = __webpack_public_path__ + "54cf98f5/img/trash-icon.ff8201c7.svg";